module.exports = new __parcel__URL__("coin-purple.19ad91e6.svg").toString();